import { combineReducers } from "@reduxjs/toolkit";
import { authReducer } from "../pages/sing-in/slice";

export const rootReducer = combineReducers({
  auth: authReducer,
});
